module.exports = __webpack_public_path__ + "img/FormatBrushIcon.63a3fc15.svg";